export default {
  baseInfo: {
    title: '基本信息',
  },
  invoice: {
    title: '发票进度',
    step1: {
      title: '申请提交',
      content: '已于12月21日提交',
    },
    step2: {
      title: '电子发票',
      content: '预计1～3个工作日',
    },
    step3: {
      title: '发票已邮寄',
      content: '电子发票开出后7个工作日联系',
    },
    step4: {
      title: '完成',
    },
  },
  product: {
    title: '产品目录',
    add: '新增产品',
    month: '月份',
    quarter: '季度',
  },
  detail: {
    title: '产品采购明细',
    form: {
      applyNo: '申请号',
      product: '产品名称',
      productNo: '产品编号',
      operation: '操作',
      department: '申请部门',
      num: '采购数量',
      createTime: '创建时间',
      manage: '管理',
      delete: '删除',
    },
  },
};
